export function isOrderEntry(entry) {
  return entry.causer?.order_id || false
}
